<template>
  <div class="g-deduction-list">
    <div class="deduction-list-top">
      <div class="top-l">
        <el-input v-model="VIN" clearable placeholder="请输入VIN"></el-input>
        <el-date-picker
        v-model="start_date"
        type="date"
        placeholder="选择开始日期">
        </el-date-picker>
        <el-date-picker
        v-model="end_date"
        :picker-options="pickerOptions1"
        type="date"
        placeholder="选择结束日期">
        </el-date-picker>
        <el-button class="top-l-search" @click="searchClick()">查询</el-button>
        <div style="clear:both;"></div>
      </div>
      <div style="clear:both;"></div>
    </div>
    <div class="deduction-list-bottom">
      <div class="deduction-list-table">
        <el-table
        :data="yemiandata"
        :header-cell-style="{background:'#f3f3f3',color:'#323232',height:'50px'}"
        border
        style="width: 100%">
            <el-table-column
            prop="customer_name"
            label="客户"
            width="130">
            </el-table-column>
            <el-table-column
            prop="vin"
            label="VIN"
            width="150">
            </el-table-column>
            <el-table-column
            prop="batch"
            label="订单号">
              <template slot-scope="scope">
                <span v-if="scope.row.batch==0">--</span>
                <span v-else>{{ scope.row.batch }}</span>
              </template>
            </el-table-column>
            <el-table-column
            prop="batch_s"
            label="是否临时结算"
            width="110">
              <template slot-scope="scope">
                <span v-if="scope.row.batch==0">--</span>
                <span v-else-if="scope.row.batch_s==0">正常结算</span>
                <span v-else-if="scope.row.batch_s==1">临时结算</span>
              </template>
            </el-table-column>
            <el-table-column
            prop="fee"
            label="扣除费用"
            width="110">
            </el-table-column>
            <el-table-column
            prop="balance"
            label="余额"
            width="110">
            </el-table-column>
            <el-table-column
            prop="timestamp"
            label="时间">
            </el-table-column>
            <el-table-column
            prop="last_charge_degree"
            label="上次结算电表读数"
            width="140">
              <template slot-scope="scope">{{ scope.row.last_charge_degree | defaultValFilter }}</template>
            </el-table-column>
            <el-table-column
            prop="this_charge_degree"
            label="本次结算电表读数"
            width="140">
              <template slot-scope="scope">{{ scope.row.this_charge_degree | defaultValFilter }}</template>
            </el-table-column>
            <el-table-column
            prop="charge_power"
            label="用电量"
            width="100">
              <template slot-scope="scope">{{ scope.row.charge_power | defaultValFilter }}</template>
            </el-table-column>
            <el-table-column
            prop="pay_type"
            label="结算类型"
            width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.pay_type==1">用电量结算</span>
                <span v-else-if="scope.row.pay_type==2">充电量结算</span>
                <span v-else>--</span>
              </template>
            </el-table-column>
            <el-table-column
            prop="serv_fee"
            label="服务费"
            width="100">
              <template slot-scope="scope">{{ scope.row.serv_fee | defaultValFilter }}</template>
            </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          @size-change="handleSizeChange"
          @current-change="currentChange"
          :total="totalNum"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { parseDateFilter } from "@/filters";
export default {
  data() {
    return {
      tableData: [],
      // 页面需要展现的数据
      yemiandata: [],
      // 页面展现条数
      datanum: 10,
      // 开始页数
      startnum: 0,
      // 结束页数
      endnum: 1,
      // 一共多少页
      totalNum: 0,
      value: "",
      options:[],
      VIN:"",
      start_date:"",
      end_date:"",
      pickerOptions1: {
        disabledDate: (time) => {
          return time.getTime() < this.start_date || time.getTime() > Date.now();
        }
      },
    };
  },
  mounted() {
    this.$nextTick(function() {
      this.getDataList();
    });
  },
  methods: {
    handleSizeChange(data){
      // debugger
    },
    currentChange(data){
      this.endnum = data;
      this.startnum = data-1;
      // this.yemiandata=this.tableData.slice(this.startnum*this.datanum,this.endnum*this.datanum);
      if(this.totalNum > 10){
        this.yemiandata=this.tableData.slice(this.startnum*this.datanum,this.endnum*this.datanum);
      } else {
        this.yemiandata=this.tableData;
      }
    },
    getDataList(vin,startTime,endTime){
      if(vin == undefined){
        vin = "";
      }
      if(startTime == undefined){
        startTime = "";
      }
      if(endTime == undefined){
        endTime = "";
      }
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action:"getCustomerVinConsumeLogs",
        vin:vin,
        start_date:startTime ? parseDateFilter(startTime, 'yyyy-MM-dd') : '',
        end_date:endTime ? parseDateFilter(endTime, 'yyyy-MM-dd') : '',
      };
      this.$api({
        method: "post",
        url: "/api.php/Customer2/index",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if (su.data.code == 1) {
            this.tableData = su.data.list;
            this.totalNum = this.tableData.length;
            if(this.totalNum > 10){
              // debugger
              this.yemiandata=this.tableData.slice(this.startnum*this.datanum,this.endnum*this.datanum);
            } else {
              this.yemiandata=this.tableData;
            }
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900)  {
          } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch(err => {});
    },
    searchClick(){
      this.startnum = 0;
      this.endnum = 1;
      this.totalNum = 0;
      this.getDataList(this.VIN,this.start_date,this.end_date);
    },
  }
};
</script>

<style scoped lang="scss">
.g-deduction-list {
  padding:20px 0;
  .deduction-list-top {
    .top-l {
      float: left;
      margin-left: 1%;
      .el-select {
        float: left;
        margin-right: 10px;
      }
      .el-input {
        width: 20%;
        float: left;
        margin-right: 10px;
      }
      .top-l-search {
        background-color: #0071bd;
        border: none;
        color: #fefffd;
        margin-left: 16px;
        float: left;
      }
    }
  }
  .deduction-list-bottom {
    .deduction-list-table {
        width: 98%;
        margin-left: 1%;
        margin-top: 26px;
        margin-bottom: 10px;
        .table-btn {
            width: 54px;
            height: 30px;
            padding: 0;
            background-color: #006fbe;
            border:none;
            color: #fefffd;
            margin-left: 5px;
        }
        .table-vehicle {
            background-color: #00b270;
        }
        .table-dis {
            background-color: #eb0000;
        }
        .table-recharge {
            background-color: #ec6900;
        }
    }
    .pagination {
      display: flex;
      justify-content: flex-end;
      padding-bottom: 24px;
      margin-top: 20px;
      margin-right: 18px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/membershipManagement/gDeductionRecord.vue